<template>
    <zen-one
        :showuserinfo="false"
        :title="'Cukai Tanah: Ampun Hasil :' + cukai.no_hm"
        :crumbs="crumbs"
    >
        <z-page title="Kemaskini Ampun Hasil" :append-button="true">
            <w-flex column :gap="3">
                <w-card bg-color="" class="table-hardcode">
                    <hakmilik :cukai="cukai" />
                </w-card>
                <w-card>
                    <w-form @submit.prevent="kemaskini">
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            style="width: 20%"
                                            class="mr10"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Nama Pemilik</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>

                                <w-input
                                    v-model="namaPemilik"
                                    disabled
                                    style="color: blue; width: 100%"
                                >
                                </w-input>
                            </div>

                            <div class="xs6">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Kategori</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    placeholder=""
                                    disabled
                                    v-model="kategori"
                                    style="color: blue"
                                />
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 20%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Keluasan</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    v-model="keluasan"
                                    disabled
                                    style="color: blue"
                                ></w-input>
                            </div>
                            <div class="xs6">
                                <w-tooltip color="primary">
                                    <template #activator="{ on }">
                                        <w-badge
                                            class="mr10"
                                            style="width: 25%"
                                            round
                                            top
                                            right
                                        >
                                            <template #badge>
                                                <w-icon v-on="on">
                                                    fal fa-info-circle</w-icon
                                                >
                                            </template>
                                            <label style="color: grey"
                                                >Keluasan Maksimum</label
                                            >
                                        </w-badge>
                                    </template>
                                    Tidak Boleh Diubah
                                </w-tooltip>
                                <w-input
                                    placeholder=""
                                    disabled
                                    v-model="keluasan_mak"
                                    style="color: blue !important"
                                />
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-input
                                    v-model="tarikh_mula"
                                    disabled
                                    style="color: blue"
                                    >Tarikh Mula</w-input
                                >
                            </div>
                            <div class="xs6">
                                <w-input type="date" v-model="form.tarikh_tamat"
                                    >Tarikh Tamat</w-input
                                >
                            </div>
                        </w-flex>

                        <w-flex class="mt3">
                            <div class="xs6 mr3">
                                <w-input v-model="form.amaun" type="number"
                                    >Amaun Ampun (RM)</w-input
                                >
                            </div>
                            <div class="xs6">
                                <w-select
                                    label="Status"
                                    v-model="form.status"
                                    :items="status"
                                    :placeholder="[[stat]]"
                                />
                            </div>
                        </w-flex>

                        <div class="d-flex justify-end mt3">
                            <w-button class="my1 mr0" type="submit"
                                >Kemaskini</w-button
                            >
                        </div>
                    </w-form>
                </w-card>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import { Inertia } from "@inertiajs/inertia";
import moment from "moment";

export default {
    extends: ZResource,
    props: {
        ampunHasil: [Object],
    },
    components: {
        Hakmilik,
    },
    data() {
        var moment = require("moment");
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Ampun Hasil", route: "/cukai-tanah/ampun-hasil" },
                {
                    label: "Kemaskini Ampun Hasil",
                    route: "/cukai-tanah/senarai",
                },
            ],
            cukai: [],
            cukais: [],
            form: {
                hm_akaun_id:null,
                no_tauliah: this.ampunHasil.no_tauliah,
                tarikh_tamat: null,
                // amaun_cukai: null,
                amaun: null,
                // peratus_ampun: null,
                // status: null,
                id: null,
            },
            keluasan: null,
            keluasan_mak: null,
            tarikh_mula: null,
            namaPemilik: null,
            kategori: null,
            status: [
                { value: 1, label: "Aktif" },
                { value: 0, label: "Tidak Aktif" },
            ],
            stat: null,
            tarikh_tamat: null,
        };
    },
    methods: {
        async kemaskini() {
            await axios({
                method: "put",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil/${this.form.id}`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        console.log(e.data);
                    }
                })
                .finally((e) => {
                    window.location.href = `/cukai-tanah/ampunHasil/${this.cukai.no_hm}`;
                });
            // Inertia.post("/cukai-tanah/kemaskini-ampun-hasil",l);
        },
        async searchCukai() {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                barcode: this.ampunHasil.no_hm,
                kodDaerah: "01",
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            }).then((e) => {
                if (e.data.length > 0) {
                    this.cukai = e.data[0];
                    this.form.hm_akaun_id = e.data[0].id;
                }
            });
        },
        async getData() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/ampun-hasil?id=${this.ampunHasil.no_hm}`,
                params: {
                    limit: 100,
                    offset: 0,
                },
                responseType: "json",
            }).then((e) => {
                const { data } = e.data;
                this.cukais = data[0];
                console.log(this.cukais.no_hm);
                this.searchCukai(this.cukais.no_hm);

                if(e.data.data[0].tarikh_mula!=null){
                    this.tarikh_mula = moment(e.data.data[0].tarikh_mula).format("YYYY-MM-DD");
                }
                else{
                    this.tarikh_mula='Tiada Tarikh';
                }
                if(e.data.data[0].tarikh_tamat!=null){
                     this.form.tarikh_tamat = moment(e.data.data[0].tarikh_tamat).format("YYYY-MM-DD");
                }
                else{
                    this.form.tarikh_tamat='Tiada Tarikh';
                }

                this.form.amaun = data[0].amaun;
                // this.form.peratus_ampun = data[0].peratus_ampun;
                this.stat = data[0].status;
                this.keluasan = data[0].keluasan;
                this.keluasan_mak = data[0].keluasan_mak;
                this.form.id = data[0].id;
                this.kategori = data[0].kategori;
                this.namaPemilik = data[0].pemilik;
            });
        },
    },
    watch: {},
    mounted() {
        this.searchCukai();
        this.getData();
        this.dialog.width = 500;
    },
};
</script>
<style>
::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgb(35, 71, 129);
    font-style: normal;
    opacity: 1; /* Firefox */
}
</style>
